export default __webpack_public_path__ + "static/media/setDesign.493dab7a.png";